/* ==========================================================================
   SearcherTrainHotelRxjs > Client > Config
   ========================================================================== */

/* Config */
const config = {
    component: 'SearcherTrainHotelRxjs',
    init: true,
    start: true,
    css: {
        item: 'searcher__item',
        visible: 'is-visible',
        disabled: 'is-disabled',
        calendarInput: 'input-panel--calendar',
        calendarPanel: 'input-panel__panel--calendar-sfh',
        calendarFp: 'calendar-rxjs--single',
        accommodationInput: 'input-panel--accommodation',
        button: 'searcher__button'
    },
    type: {
        panel: 'ui-panel',
        origin: 'searcher-train-hotel-origin',
        destination: 'searcher-train-hotel-destination',
        calendar: 'searcher-train-hotel-calendar',
        calendarInput: 'searcher-train-hotel-calendar-input',
        accommodation: 'searcher-train-hotel-accommodation',
        addRoom: 'searcher-train-hotel-add-rom',
        loading: 'searcher-train-hotel-loading',
        submit: 'searcher-train-hotel-submit'
    },
    hooks: {
        panelContent: 'data-searcher-train-hotel-panel-content',
        panelBody: 'data-searcher-train-hotel-panel-body'
    },
    onModal: false,
    showLoading: true,
    url: '/packagesasyncstepssp/AvailabilityMaterial'
};

module.exports = () => config;
